import { Injectable } from '@angular/core';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

@Injectable({
  providedIn: 'root'
})
export class PdfExportService {

  exportToPdf(columns: any[], data: any[], applyCss: boolean = false, fileName: string = 'Export') {
    const selectedColumns = columns.filter(col => col.selected);
    const validation = this.validatePdfColumns(selectedColumns);

    const headers = selectedColumns.map(col => col.label);
    const rows = data?.map((row: any) =>
      selectedColumns.map(col => row[col.field] ?? '')
    );

    const orientation = validation.orientation === 'landscape' ? 'l' : 'p';
    const doc = new jsPDF(orientation, 'mm', 'a4');
    const pageWidth = orientation === 'l' ? 297 : 210;

    const img = new Image();
    img.onload = () => {
      this.generatePdf(doc, pageWidth, headers, rows, selectedColumns, data, applyCss, fileName, img);
    };
    img.onerror = () => {
      this.generatePdf(doc, pageWidth, headers, rows, selectedColumns, data, applyCss, fileName, null);
    };
    img.src = 'assets/meraki-logo.png';
  }

  private generatePdf(doc: any, pageWidth: number, headers: any[], rows: any[], selectedColumns: any[], data: any[], applyCss: boolean, fileName: string, logoImg: HTMLImageElement | null) {
    autoTable(doc, {
      head: [headers],
      body: rows,
      startY: 20,
      theme: 'grid',
      tableWidth: pageWidth - 20,
      styles: {
        fontSize: 7,
        cellPadding: 2,
        overflow: 'linebreak',
        halign: 'left',
        valign: 'middle',
        cellWidth: 'wrap'
      },
      headStyles: {
        fontSize: 7,
        fontStyle: 'bold',
        textColor: [255, 255, 255],
        fillColor: [22, 160, 133],
        halign: 'center',
        valign: 'middle',
        cellPadding: 2,
        overflow: 'visible',
        minCellHeight: 8,
        cellWidth: 'auto'
      },
      columnStyles: selectedColumns.reduce((acc: any, col: any, index: number) => {
        acc[index] = {
          cellWidth: 'auto',
          overflow: 'linebreak'
        };
        return acc;
      }, {}),
      didParseCell: (hookData: any) => {
        if (applyCss && hookData.section === 'body') {
          const rowData = data[hookData.row.index];
          if (rowData?.due_color) {
            hookData.cell.styles.fillColor = rowData.due_color;
          }
        }
      },
      didDrawPage: (data: any) => {
        if (logoImg) {
          try {
            doc.addImage(logoImg, 'PNG', 10, 5, 20, 10);
          } catch (e) {
            console.error('Error adding logo:', e);
          }
        }
        doc.setFontSize(12);
        doc.text('Meraki Greatlakes Shipping and Technical', pageWidth / 2, 10, { align: 'center' });
        doc.setFontSize(10);
        doc.text('Management L.L.C-FZ', pageWidth / 2, 15, { align: 'center' });
      },
      margin: { top: 20, right: 10, bottom: 10, left: 10 }
    });

    doc.save(`${fileName}_${new Date().toISOString().split('T')[0]}.pdf`);
  }

  private validatePdfColumns(selectedColumns: any[]): { valid: boolean; message?: string; orientation?: string } {
    const portraitWidth = 190;
    const landscapeWidth = 270;

    const totalWidth = selectedColumns.reduce((sum, col) => {
      const labelLength = col.label?.length || 10;
      return sum + Math.max(labelLength * 2, 20);
    }, 0);

    if (totalWidth <= portraitWidth) {
      return { valid: true, orientation: 'portrait' };
    } else if (totalWidth <= landscapeWidth) {
      return { valid: true, orientation: 'landscape' };
    } else {
      return {
        valid: false,
        message: "Selected columns are too wide. Try reducing columns"
      };
    }
  }
}
